import { FreightClaimsApi } from "@/Apis/FreightClaimsApi";
import { Configuration } from "@freightsimple/generated-dashboard-openapi-client/runtime";
import { useAuthentication } from "@/Slices/authenticationSlice";
import { getConfig } from "@/Apis/getConfig";

export function useFreightClaimsApi(): FreightClaimsApi {
  const { accessToken } = useAuthentication();

  return new FreightClaimsApi(
    new Configuration({ ...getConfig(), accessToken: accessToken }),
  );
}
